import axios from 'axios';

export async function findProperty(inputAddress, maxResults) {
  try {
    return await axios.post(
      `${process.env.REACT_APP_MCCC_API_URL}/refi/property/find`,
      {
        address: inputAddress,
        maxResults,
      },
    );
  } catch (error) {
    console.error(error);
    return error;
  }
}
